import React from 'react';
import { Mic2, BookOpen, Users, Trophy } from 'lucide-react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <Mic2 className="w-6 h-6" data-id="element-164" />,
    title: t('solution', 'f1Title'),
    desc: t('solution', 'f1Desc')
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-165" />,
    title: t('solution', 'f2Title'),
    desc: t('solution', 'f2Desc')
  }, {
    icon: <Users className="w-6 h-6" data-id="element-166" />,
    title: t('solution', 'f3Title'),
    desc: t('solution', 'f3Desc')
  }, {
    icon: <Trophy className="w-6 h-6" data-id="element-167" />,
    title: t('solution', 'f4Title'),
    desc: t('solution', 'f4Desc')
  }];
  return <Section background="charcoal" id="solution" data-id="element-168">
      <div ref={ref} className={`flex flex-col md:flex-row items-center gap-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-169">
        {/* Image Side */}
        <div className="w-full md:w-1/2 relative" data-id="element-170">
          <div className="absolute inset-0 bg-brand-blue rounded-2xl rotate-3 opacity-10 blur-sm" data-id="element-171"></div>
          <div className="relative bg-gradient-to-br from-slate-100 to-slate-200 border border-slate-200 rounded-2xl p-2 shadow-2xl" data-id="element-172">
            <img src="https://cdn.magicpatterns.com/uploads/mL1MdYQp7FQstvL311bcq7/0PNIY9o_DrylKK6hwQdqo.png" alt="Micrófono profesional en estudio con luces neón" className="rounded-xl w-full h-auto object-cover transition-all duration-500" data-id="element-173" />
            {/* Badge */}
            <div className="absolute -bottom-6 -right-6 bg-brand-blue text-white font-heading font-bold text-xl px-6 py-4 rounded-lg shadow-lg rotate-[-5deg] border-4 border-white" data-id="element-174">
              {t('solution', 'badge')}
            </div>
          </div>
        </div>

        {/* Content Side */}
        <div className="w-full md:w-1/2" data-id="element-175">
          <h3 className="text-brand-blue-light font-bold tracking-widest uppercase mb-2" data-id="element-176">
            {t('solution', 'subtitle')}
          </h3>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-6 leading-tight" data-id="element-177">
            {t('solution', 'title1')} <br data-id="element-178" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-blue to-brand-blue-light" data-id="element-179">
              {t('solution', 'title2')}
            </span>
          </h2>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-180">
            {t('solution', 'desc')}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-181">
            {features.map((feature, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-182">
                <div className="w-10 h-10 rounded-full bg-brand-blue/10 flex items-center justify-center text-brand-blue shrink-0" data-id="element-183">
                  {feature.icon}
                </div>
                <div data-id="element-184">
                  <h4 className="font-bold text-brand-navy mb-1" data-id="element-185">
                    {feature.title}
                  </h4>
                  <p className="text-sm text-slate-500" data-id="element-186">{feature.desc}</p>
                </div>
              </div>)}
          </div>

          <a href={t('hero', 'ctaLink')} target="_blank" rel="noopener noreferrer" data-id="element-187">
            <Button variant="primary" size="lg" withIcon data-id="element-188">
              {t('solution', 'cta')}
            </Button>
          </a>
        </div>
      </div>
    </Section>;
}